var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.show(_vm.params))?_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){return _vm.clickHandler()}}},[_c('v-icon',{attrs:{"color":"var(--v-resBlue-darken1)"}},[_vm._v(_vm._s(_vm.icon))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }